import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Mechanism",
  "use": "Mechanism-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Mechanism\"><path d=\"M18.792 11.989a1 1 0 0 1 .117 1.993l-.117.007H8.502L8.5 15.787a.5.5 0 0 1-.854.354l-3.293-3.293a.5.5 0 0 1 .354-.854l1.985.001.1-.006h12ZM16 5.69a.5.5 0 0 1 .354.147l3.293 3.293a.5.5 0 0 1-.354.853h-1.985l-.1.006h-12a1 1 0 0 1-.116-1.994l.117-.006h10.29L15.5 6.19a.5.5 0 0 1 .5-.5Z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol